import { withStyles } from "@material-ui/core";
import styles from "./styles";
import PopupFieldRenderer from "./common/PopupFieldRenderer";
import constants from "./constants";
const TrailerDropHookStopPopup = ({ task, classes }) => {
  const stopType =
    task?.data?.stopType === "TrailerDrop" ? "Trailer Drop" : "Trailer Hook";
  return (
    <div className={classes.popupContainer}>
      <PopupFieldRenderer
        label={stopType}
        value={task?.data?.name}
        valueClassName={classes.headerRowValue}
        rowClassName={classes.headerRowContainer}
        labelClassName = {classes.headerLabel}
      />
      <div className={classes.multipleColumnRowContainer}>
        <PopupFieldRenderer label={constants.POPUP_LABELS.ARRIVAL_TIME} value={task.arrivalTime} />
        <PopupFieldRenderer label={constants.POPUP_LABELS.BILLS} value={task.data.numberOfBills} />
      </div>
    </div>
  );
};

export default withStyles(styles)(TrailerDropHookStopPopup);
